<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "InformasiCampaignUser",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
